import { useMutation } from 'react-query'
import { downloadFile, onDownloadSuccess } from '../api/shared/downloadFile'
import { API_ERROR_MESSAGE } from '../utils/Constants'

export const useDownloadFile = (
  path: string,
  reportId: string,
  reportTypeId: number,
  setIsError?: (isError: boolean) => void,
  setErrorMessage?: (errorMessage: string) => void,
) => {
  const mutationContext = useMutation(
    [path, reportId, reportTypeId],
    async (_reportId?: string) =>
      downloadFile(path, _reportId || reportId, reportTypeId),
    {
      onSuccess: onDownloadSuccess,
      onError: () => {
        if (setIsError) setIsError(true)
        if (setErrorMessage) setErrorMessage(API_ERROR_MESSAGE)
      },
    },
  )
  return mutationContext
}
